import { PageLayout } from '../../components'
import { useUserRenderWrapper } from '../../hooks'
import { MainContent } from './components'

interface MainPageProps {
  showNews: boolean
}

/**
 * Main page container.
 * Composition of main page components.
 */
export const MainPage = ({ showNews }: MainPageProps) => {
  const { UserRenderWrapper, user, employmentSummary, membershipSummary } =
    useUserRenderWrapper()

  return (
    <PageLayout showBottomBar>
      <UserRenderWrapper>
        {user && employmentSummary && membershipSummary && (
          <MainContent
            user={user}
            employmentSummary={employmentSummary}
            membershipSummary={membershipSummary}
            showNews={showNews}
          />
        )}
      </UserRenderWrapper>
    </PageLayout>
  )
}
